import React from "react";
import MixMastersHero from "../../components/User/Home/Mixmastershero";
import MixMastersServices from "../../components/User/Home/Mixmastersservices ";
import MixMastersProducts from "../../components/User/Home/Mixmastersproducts";
import MixMastersAbout from "../../components/User/Home/Mixmastersabout";
import MixMastersFeatures from "../../components/User/Home/Mixmastersfeatures ";
import MixMastersProjects from "../../components/User/Home/Mixmastersprojects";
import MixMastersFAQ from "../../components/User/Home/Mixmastersfaq";
import MixMastersHowItWorks from "../../components/User/Home/Mixmastershowitworks";
import MixMastersContact from "../../components/User/Home/Mixmasterscontact";
import MixMastersPartners from "../../components/User/Home/Mixmasterspartners ";
import MixMastersPartners1 from "../../components/User/Home/Mixmasterspartners1";
import CTABanner from "../../components/common/CTABanner";
import ReviewCarousel from "../../components/User/Common/ReviewCarousel";

const Home = () => (
  <div className="overflow-hidden ">
    <MixMastersHero />
    <MixMastersServices />
    <MixMastersProducts />
    <MixMastersAbout />
    <MixMastersProjects />
    <MixMastersFeatures />
    <MixMastersPartners />
    <MixMastersContact />
    <MixMastersHowItWorks />
    <MixMastersPartners1 />
    <MixMastersFAQ />
    <ReviewCarousel/>
    <CTABanner />
  </div>
);

export default Home;
